import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoMenyyElement = _resolveComponent("VoMenyyElement")!
  const _component_KasutajaInfo = _resolveComponent("KasutajaInfo")!
  const _component_VoMenyy = _resolveComponent("VoMenyy")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VoMenyy, null, {
      elemendid: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.juurdepaasPoleLubatudMenuu(), (item) => {
          return (_openBlock(), _createBlock(_component_VoMenyyElement, {
            key: item.url,
            pealkiri: item.pealkiri,
            url: item.url,
            ikoon: item.ikoon,
            "active-class": "list-item-active"
          }, null, 8, ["pealkiri", "url", "ikoon"]))
        }), 128))
      ]),
      kasutaja: _withCtx(() => [
        _createVNode(_component_KasutajaInfo)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, { style: {"min-height":"1000px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "24" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "title")
                          ]),
                          _: 3
                        })
                      ]),
                      _: 3
                    }),
                    _renderSlot(_ctx.$slots, "body")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 64))
}